module.exports = __webpack_public_path__ + "static/media/960dc1c1fb4887fb84d869425ea2b881.960dc1c1.webp";